export default __webpack_public_path__ + "static/media/webda.9e15f2fb.svg";